import api from "../index";
import { qs } from "../../utils/utils";

export const LoginApi = (data) => api.post("authentication/login", data);
export const OtpApi = (data) => api.post("authentication/login-verify-otp", data);
export const RegisterApi = (data) => api.post("usermaster/trader-register", data);

export const SendOtpApi = (data) => api.post("authentication/login-resend-otp", data);

export const ResetApi = (data) => api.post("authentication/forgot-password", data);

export const ChangePasswordApi = (data) => api.post("Authentication/Change-Password", data);

export const UpdateParentVisibilityApi = (userId, params) => api.patch(`UserMaster/update-parent-detail-show-status/${userId}?${qs(params)}`);
export const LogoutApi = (data) => api.post("Authentication/Logout", data);

export const ClearNotificationApi = () => api.delete(`notification/user/clear-all-notifications`);
export const MarkAsReadNotificationApi = (notificationId) => api.put(`notification/update-notification-status`, notificationId);

export const SendemailApi = (data) => api.post(`authentication/send-otp-email?Email`, data);

export const GetUserApi = (userId) => api.get(`admin/getsingleuser/${userId}`);

export const UpdateUserApi = (data, apiHeader) => api.put("usermaster/update-user-details", data, apiHeader);

export const ForgetOtpApi = (data) => api.post("authentication/forgot-password-verify-otp", data);

export const GetParentTreeApi = (params) => api.get(`ibusermaster/get-parent-ibtree/${qs(params)}`);

export const GetNotificationApi = () => api.get("notification/get-user-messages");

export const UpdateParentDetaialsApi = (data) => api.post(`ibusermaster/update-parent-details-status`, data);

export const GetUserInfoApi = (userId) => api.get(`trading/get-client-info/${userId}`);
export const UpdateUserInfoApi = (data) => api.put('trading/update-client-info', data);

export const Request2faChangeApi = (params) => api.put(`usermaster/request-2fa-change?${qs(params)}`);
export const Verify2faChangeApi = (data) => api.put('usermaster/verify-2fa-change', data);